import React from 'react';
import ProductsCarouselByTag from '../ProductsCarouselByTag/ProductsCarouselByTag';

const ModuleProductsCarouselByTag = ({
  seoName,
  productsCarouselVersion,
  coloredBackgroundProducts,
  sliderCircleArrowsProducts,
  primaryColor,
  secondaryColor,
}) => {
  return (
    <ProductsCarouselByTag
      seoName={seoName}
      productsCarouselVersion={productsCarouselVersion}
      coloredBackgroundProducts={coloredBackgroundProducts}
      sliderCircleArrowsProducts={sliderCircleArrowsProducts}
      primaryColor={primaryColor}
      secondaryColor={secondaryColor}
    />
  );
};
export default ModuleProductsCarouselByTag;
